import React from 'react';

import {
  Step, Table
} from 'src/types';
import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import ConnectToSlackButton from 'src/components/ConnectToSlackButton';
import { FieldConfig } from 'src/components/formik/FormikConfigForm';
import useGetRequest from 'src/hooks/useGetRequest';
import FormikSelect from 'src/components/formik/FormikSelect';
import FormikSlateRichTextArea from '../../../../components/formik/FormikSlateRichTextArea';
import FormikFilesDropzone from '../../../../components/formik/FormikMultiFilesDropzone';
import FormikInput from '../../../../components/formik/FormikInput';
import FormikSingleFileDropzone from '../../../../components/formik/FormikSingleFileDropzone';

interface Props {
  step: Step,
}

const DocumentGeneratorForm = ({ step }: Props) => {
  const fieldsConfig: FieldConfig[] = [
    {
      name: 'field',
      fields: [
        {
          name: 'name',
          component: () => (
            <FormikInput
              fullWidth
              label="Field name"
              name="field.name"
            />
          ),
        },
      ]
    },
    {
      name: 'document'
    },
    {
      name: 'documentName',
      component: () => (
        <FormikSlateRichTextArea
          label="Document name"
          name="documentName"
          workflowId={step.workflowId}
        />
      ),
    },
    {
      name: 'documentId',
      component: () => (
        <FormikSingleFileDropzone
          name="documentId"
          label="Template"
          multiple={false}
        />
      ),
    },
  ];

  return (
    <CRUDConfigForm
      url={`/automatic/workflows/${step.workflowId}/document-generators/`}
      objectId={step.action && step.action.documentGenerator && step.action.documentGenerator.id}
      fieldsConfig={fieldsConfig}
      autoSave
    />
  );
};

export default DocumentGeneratorForm;
